<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'COMPLAINT|Podgląd reklamacji' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>

    <div class="dialog-body">
        <icc-complaint-summary
            [document]="data.document"
            [preview]="true"
        ></icc-complaint-summary>
        <ng-container *ngIf="data.document as document">
            <div
                class="complainant-preview"
                *ngIf="document.clientName || document.clientPhoneNumber || document.clientEmail || document.installationAddress || document.locationDescription || markerPosition"
            >
                <div class="complainant-preview__header">
                    {{ 'COMPLAINT|Pierwotne dane reklamującego' | translate }}
                </div>
                <div class="complainant-preview__content">
                    <div class="complainant-preview__row" *ngIf="document.clientName">
                        <span class="complainant-preview__label">{{ 'COMPLAINT|Imię i nazwisko' | translate }}</span>
                        <span class="complainant-preview__value">{{ document.clientName }}</span>
                    </div>
                    <div class="complainant-preview__row" *ngIf="document.clientEmail">
                        <span class="complainant-preview__label">{{ 'COMPLAINT|Adres e-mail' | translate }}</span>
                        <span class="complainant-preview__value">{{ document.clientEmail }}</span>
                    </div>
                    <div class="complainant-preview__row" *ngIf="document.clientPhoneNumber">
                        <span class="complainant-preview__label">{{ 'COMPLAINT|Nr telefonu' | translate }}</span>
                        <span class="complainant-preview__value">{{ document.clientPhoneNumber }}</span>
                    </div>
                    <div class="complainant-preview__row" *ngIf="document.installationAddress">
                        <span class="complainant-preview__label">{{ 'COMPLAINT|Adres instalacji' | translate }}</span>
                        <span class="complainant-preview__value">
                            {{ document.installationAddress }}
                            <span *ngIf="document.locationSource === 'manual'">({{ 'COMPLAINT|znacznik ustawiony ręcznie' | translate }})</span>
                            <span *ngIf="document.locationPartialMatchConfirmed && document.locationSource !== 'manual'">({{ 'COMPLAINT|tylko częściowa zgodność adresu – pozycja znacznika potwierdzona przez Klienta' | translate }})</span>
                        </span>
                    </div>
                    <div class="complainant-preview__row" *ngIf="document.locationDescription">
                        <span class="complainant-preview__label">{{ 'COMPLAINT|Opis lokalizacji' | translate }}</span>
                        <span class="complainant-preview__value">{{ document.locationDescription }}</span>
                    </div>
                    <ng-container *ngIf="markerPosition as position">
                        <div class="complainant-preview__row">
                            <span class="complainant-preview__label">{{ 'COMPLAINT|Współrzędne' | translate }}</span>
                            <span class="complainant-preview__value">
                                {{ position.lat | number:'1.6-6' }}, {{ position.lng | number:'1.6-6' }}
                            </span>
                        </div>
                        <div
                            class="complainant-preview__map"
                            *ngIf="apiLoaded && !mapLoadError"
                        >
                            <google-map
                                [zoom]="mapZoom"
                                [center]="position"
                                [options]="{
                                    fullscreenControl: true,
                                    mapTypeControl: false,
                                    streetViewControl: false,
                                    zoomControl: true
                                }"
                            >
                                <map-marker [position]="position"></map-marker>
                            </google-map>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <div class="product-elements">
            <ng-container *ngFor="let position of data.positions; index as id;">
                <icc-complaint-position
                    [position]="position"
                    [showDetails]="true"
                    [positionTitle]="positionsTitles.get(position.uuid)"
                    [attachments]="data.attachments"
                    [document]="data.document"
                    [id]="position.uuid"
                    [index]="id"
                    [preview]="true"
                ></icc-complaint-position>
            </ng-container>
        </div>
        <div>
            <ng-container *ngFor="let consent of data.document.consents; let i = index">
                <div class="complaint-form__checkbox">
                    <icc-checkbox
                        [name]="'consent' + consent.id"
                        [ngModel]="consent.checked"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="true"
                    >
                        <span class="complaint-form__consent" [style.fontWeight]="(consent.required) ? 'bold' : 'normal'" [innerHTML]="consent.shortDescription"></span>
                    </icc-checkbox>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="dialog-footer">

        <div class="flex-horizontal w-100">

            <button
                iccButton
                (click)="close()"
                appearance="secondary"
            >
                {{ 'INTERFACE|Zamknij' | translate}}
            </button>

        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
